const state = {
  table: []
};

export default {
  state
};
